import * as types from 'modules/users/actionTypes';

import { getUsers } from '.';

/**
 * @param {import("../reducer/ui/impersonate").ImpersonateFilterField} field
 * @param {string | string[]} value
 * @param {Object} [meta={}]
 * @returns {import("../types/actions").SetImpersonateModalFilterAction}
 */
export const setImpersonateModalFilter = (field, value, meta = {}) => ({
  type: types.SET_IMPERSONATE_MODAL_FILTER,
  payload: { field, value },
  meta,
});

/**
 * @param {import("../types/actions").ImpersonateFilter[]} filters
 * @param {Object} [meta={}]
 * @returns {import("../types/actions").SetImpersonateModalFiltersAction}
 */
export const setImpersonateModalFilters = (filters, meta = {}) => ({
  type: types.SET_IMPERSONATE_MODAL_FILTERS,
  payload: filters,
  meta,
});

/**
 * @param {import("../reducer/ui/impersonate").ImpersonateFilterField} field
 * @param {string|string[]} value
 * @param {Object} [meta={}]
 * @returns {import("../types/actions").RemoveImpersonateModalFilterAction}
 */

const removeImpersonateModalFilter = (field, value, meta = {}) => ({
  type: types.REMOVE_IMPERSONATE_MODAL_FILTER,
  payload: {
    field,
    value,
  },
  meta,
});

/**
 * @param {unknown} payload
 * @param {Object} [meta={}]
 * @returns {import("../types/actions").ClearImpersonateModalFilterAction}
 */
export const clearImpersonateModalFilters = (payload, meta = {}) => ({
  type: types.CLEAR_IMPERSONATE_MODAL_FILTER,
  payload,
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import("../types/actions").OpenImpersonateModalAction}
 */
export const openImpersonateModal = meta => ({
  type: types.OPEN_IMPERSONATE_MODAL,
  payload: undefined,
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import("../types/actions").CloseImpersonateModalAction}
 */
export const closeImpersonateModal = meta => ({
  type: types.CLOSE_IMPERSONATE_MODAL,
  payload: undefined,
  meta,
});

/**
 * @param {Object} params
 * @param {Object} [meta={}]
 * @returns {import("../types/actions").GetImpersonateUsersAction}
 */
export const getImpersonateUsers = (params, meta = {}) => getUsers(params, { ...meta, source: 'impersonate' });
